"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePage = void 0;
var Invoice_1 = require("./Invoice");
Object.defineProperty(exports, "InvoicePage", { enumerable: true, get: function () { return Invoice_1.InvoicePage; } });
